import { Group, Text, ThemeIcon } from '@mantine/core'
import { IconBuildingStore, IconUser } from '@tabler/icons-react'

export function CustomerBlock({
  name,
  phoneNumber,
  variant = 'individual',
}: {
  name: string
  phoneNumber?: string | null
  variant?: 'individual' | 'organization'
}) {
  const Icon = variant === 'organization' ? IconBuildingStore : IconUser

  return (
    <Group>
      <ThemeIcon variant="light" size="lg" radius="md">
        <Icon size={20} />
      </ThemeIcon>
      <div>
        <Text fw={700}>{name}</Text>
        {phoneNumber && (
          <Text size="sm" c="dimmed">
            {phoneNumber}
          </Text>
        )}
      </div>
    </Group>
  )
}
